import { render } from "./digitalRoleView.vue?vue&type=template&id=16bebcdc&scoped=true&ts=true"
import script from "./digitalRoleView.vue?vue&type=script&lang=ts"
export * from "./digitalRoleView.vue?vue&type=script&lang=ts"

import "./digitalRoleView.vue?vue&type=style&index=0&id=16bebcdc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bebcdc"]])

export default __exports__